/** Framer Motion: scale + opacity only (no vertical travel). */
export function fadeScaleProps(delay = 0) {
  return {
    initial: { opacity: 0, scale: 0.98 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.45, delay, ease: [0.16, 1, 0.3, 1] },
  }
}

export const M_CARD =
  'rounded-2xl border border-[#1B2A6B]/[0.08] bg-white p-5 shadow-[0_4px_20px_rgba(0,0,0,0.06)]'

export const M_IMAGE_FRAME =
  'w-full overflow-hidden rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-[#1B2A6B]/[0.06]'
